var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Outline/log-out-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/log-out-outline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, -0.000000)",
    fill: "#474747",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8102001,6.93060003 L17.8707001,5.87010002 L23.9997001,11.9991 L17.8707001,18.1296001 L16.8102001,17.0691001 L21.1287001,12.7491001 L10.8402,12.7491001 L10.8402,11.2491 L21.1287001,11.2491 L16.8102001,6.93060003 Z M13.5,22.5 L13.5,18.7500001 L15,18.7500001 L15,22.5 C15,23.3280001 14.3280001,24 13.5,24 L1.5,24 C0.672000003,24 0,23.3280001 0,22.5 L0,1.5 C0,0.672000003 0.672000003,0 1.5,0 L13.5,0 C14.3280001,0 15,0.672000003 15,1.5 L15,5.25000002 L13.5,5.25000002 L13.5,1.5 L1.5,1.5 L1.5,22.5 L13.5,22.5 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOutline);
export default __webpack_public_path__ + "static/media/logout-outline.2d346f8c74b38e0626864d4bb2ab1884.svg";
export { ForwardRef as ReactComponent };